import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'isToday'})
export class IsTodayPipe implements PipeTransform {
  transform(value: any) {
    return moment(value).isSame(new Date(), 'day');
  }
}
